import _extends from "@babel/runtime-corejs3/helpers/extends";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import React from 'react';
import cx from 'classnames';
export const withClassName = (Component, ...classNames) => props => React.createElement(Component, _extends({}, props, {
  className: cx(..._mapInstanceProperty(classNames).call(classNames, className => props.selectProps.genericSelectStyles[className]), props.className)
}));
export const getMenuListId = controlId => "".concat(controlId, "--menu-list");